import React from "react";

const NoDataFound = () => {
    return (
        <div style={{
            width: '100%',
            background: '#bae1c4',
            padding: '15px',
            fontSize: '20px',
            borderRadius: '15px'
        }}>
            No data found!
        </div>
    );
}

export default NoDataFound;